import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "studioops_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ value, at: new Date().toISOString() })
      );
    } catch (e) {
      /* localStorage unavailable */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60]"
    >
      <div className="bg-bg-surface border border-white/15 rounded-2xl shadow-glow backdrop-blur-md p-5 flex flex-col gap-3">
        <div className="flex items-start gap-3">
          <div className="rounded-full bg-brand/15 text-brand p-2 mt-0.5">
            <Cookie size={18} />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-ink-primary mb-1">
              Cookies &amp; Datenschutz
            </h3>
            <p className="text-xs text-ink-muted leading-relaxed">
              Wir verwenden ausschließlich technisch notwendige Cookies, um
              StudioOps Food zu betreiben (Login, Sicherheit, Spracheinstellung).
              Es findet kein Tracking statt. Mehr in unserer{" "}
              <Link
                to="/datenschutz"
                className="text-brand hover:underline"
                data-testid="cookie-consent-privacy-link"
              >
                Datenschutzerklärung
              </Link>
              .
            </p>
          </div>
        </div>
        <div className="flex gap-2 justify-end">
          <button
            data-testid="cookie-consent-decline-btn"
            onClick={() => decide("declined")}
            className="px-4 py-2 rounded-lg text-xs font-medium text-ink-muted hover:text-ink-primary hover:bg-white/5 transition-colors"
          >
            Ablehnen
          </button>
          <button
            data-testid="cookie-consent-accept-btn"
            onClick={() => decide("accepted")}
            className="px-4 py-2 rounded-lg text-xs font-semibold bg-brand text-white hover:bg-brand/90 transition-colors"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
